import React from 'react'
import { MessageType } from 'models/MessageType'
import nateraLogo from 'icons/natera_logo.png'
import { useTranslation } from 'react-i18next'

import {
  NateraLogo,
  WelcomeMessageAvatar,
  WelcomeMessageContainer,
  WelcomeMessageSubTitle,
  WelcomeMessageTitle
} from './WelcomeMessage.style'

interface Props {
  avatarLogo: string
  isFirstMessageInCurrentFlow: boolean
  message: MessageType
}

const WelcomeMessage: React.FC<Props> = ({ avatarLogo, isFirstMessageInCurrentFlow, message }) => {

  const { title, text, avatarAtlText, logoAtlText } = message

  const { t } = useTranslation()

  return (
    <WelcomeMessageContainer isFirstMessageInCurrentFlow={isFirstMessageInCurrentFlow}>
      <WelcomeMessageAvatar src={avatarLogo} alt={avatarAtlText} />
      <NateraLogo src={nateraLogo} alt={logoAtlText} />
      <WelcomeMessageTitle>
        {title}
        <WelcomeMessageSubTitle> {text} </WelcomeMessageSubTitle>
      </WelcomeMessageTitle>
    </WelcomeMessageContainer>
  )
}

export default WelcomeMessage
